var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-section"},[_c('h2',{staticClass:"app-section__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._t("app-section-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }